import React from 'react'
import ReactDOM from 'react-dom/client'
import { CacheProvider } from '@emotion/react'
import createCache from '@emotion/cache'
import App from './App.tsx'

// Create emotion cache for MUI styling
const muiCache = createCache({
  key: 'mui',
  prepend: true,
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <CacheProvider value={muiCache}>
      <App />
    </CacheProvider>
  </React.StrictMode>,
)
